export const AUTH_REQUEST_START = "AUTH_REQUEST_START";
export const AUTH_REQUEST_SUCCESS = "AUTH_REQUEST_SUCCESS";
export const AUTH_REQUEST_FAIL = "AUTH_REQUEST_FAIL";
export const AUTH_CLEAR_ERROR = "AUTH_CLEAR_ERROR";

export const AUTH_USER_REQUEST_SUCCESS = "AUTH_USER_REQUEST_SUCCESS";
export const AUTH_LOGOUT_REQUEST_SUCCESS = "AUTH_LOGOUT_REQUEST_SUCCESS";
export const AUTH_TOKEN_REFRESH_SUCCESS = "AUTH_TOKEN_REFRESH_SUCCESS";

